import { createFileRoute } from "@tanstack/react-router";
import PartsAccountInfo from "@/pages/parts-account/PartsAccountInfo";

export const Route = createFileRoute("/_partsAuth/parts-catalog/account/")({
  component: PartsAccountInfo,
});
